import React from "react"

import AddyLine from "./AddyLine"

/**
 * Display the company address. Data is passed in/down from metaData
 * @param {object} props - react props
 * @param {object} props.data - content from metaData
 */
const AddressExo = ({ data }) => {
  const { street, line02, line03, city, state, postal, country } = data

  return (
    <address>
      <p>
        <AddyLine lineFor={street} nextLine />
        <AddyLine lineFor={line02} nextLine />
        <AddyLine lineFor={line03} nextLine />
        <AddyLine>
          <AddyLine lineFor={city} inline={state} />
          <AddyLine lineFor={state} inline=" " />
          <AddyLine lineFor={postal} inline={country} />
          <AddyLine lineFor={country} />
        </AddyLine>
      </p>
    </address>
  )
}

export default AddressExo
